import React from "react";
import Tabs from "../Tabs/Tabs";
import ChannelLeadBuilderGeneral from "./ChannelLeadBuilderGeneral";
import ModalButtons from "../ModalButtons/ModalButtons";

export default class ChannelLeadBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "general",
      loading: false,
      channelLead: this.props.channel_lead,
    };
  }

  initState = () => {};

  render() {
    return (
      <div className="ChannelLeadBuilder">
        <Tabs tabs={this.tabs()} />
        {this.renderTabContent()}
        <ModalButtons
          loading={this.state.loading}
          buttons={this.buttonsForModal()}
        />
      </div>
    );
  }

  tabs = () => {
    return [
      {
        tabName: I18n.t("general"),
        targetName: "general",
        classes: this.state.activeTab == "general" ? "active" : null,
        changeHandler: this.setActiveTab,
      },
    ];
  };

  buttonsForModal = () => {
    return [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: this.onSubmit,
      },
    ];
  };

  renderTabContent = () => {
    return (
      <div className="panel panel-form">
        {/* <div className="tab-content"> */}
        <ChannelLeadBuilderGeneral
          {...this.state}
          date_format={this.props.date_format}
          statuses_obj={this.props.statuses_obj}
          onChange={this.onChange}
        />
        {/* </div> */}
      </div>
    );
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = () => {
    this.setState({ loading: true });
    $.ajax({
      type: "PUT",
      url: this.props.update_path,
      data: { channel_lead: this.state },
    }).done((response) => {
      this.setState({ loading: false });
      if (!response.errors){
        parent.hide_modal();
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("room_type_created_successfully"));
        }
      }
    });
  };
}
